import { AuditTrialOverviewResponseModel } from "../../data-model/eventsModal";
import { API_ENDPOINTS } from "../../enums/apiUrls";
import { logError } from "../../utils/customLogger";
import { getBearerToken } from "./bearerToken";

export interface GetAuditTrialOverviewPayload {
  order_id: string;
}

/**
 * Fetches the audit trail overview for a PA order.
 *
 * @param payload - Request body containing the order id
 * @returns Parsed audit trail overview response
 * @throws {Error} When the bearer token is missing or the request fails
 */
export const getAuditTrialOverview = async (
  payload: GetAuditTrialOverviewPayload,
) => {
  try {
    const token = await getBearerToken();

    if (!token) {
      throw new Error("Bearer token not available");
    }

    const response = await fetch(API_ENDPOINTS.AUDIT_TRIAL_OVERVIEW, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      throw new Error("Failed to fetch audit trial overview");
    }

    const data = await response.json();
    return data as AuditTrialOverviewResponseModel;
  } catch (error) {
    logError(error as Error, "Error in getAuditTrialOverview");
    throw error;
  }
};
